import React, { useEffect } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../ui/TextField";
import DataSelect from "../../../../../../ui/DataSelect";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import Box from "../../../../../../ui/Box";
import useRequestInfo from "./useRequestInfo";
import Progress from "../../../../../../ui/Progress";
import StateInfoField from "./StateInfoField";
import { SmallStateIcon, StateTextColor } from "../../components/StateStyles";
import Chips from "../../../../../../ui/Chips";
import RolesBadges from "./RolesBadges";
import AttachmentCard from "./AttachmentCard";
import {DataSelectField} from "./DataSelectField";

import PropTypes from 'prop-types';
import TextMaskPhone from './TextMaskPhone';

import { format, parseISO } from 'date-fns';
import ru from 'date-fns/locale/ru'

const defaultData = {
    "id":0,
    "number":"",
    "type" : null,
    "date" : "",
    "statusId" : null,
    "statusName" : "",
    "resultStatusId" : null,
    "resultStatusName":"",
    "typeName":"",
    "name": "",
    "regionId" : null,
    "regionName" : "",
    "municipalId" : null,
    "municipalName" : "",
    "email" : "",
    "accountEmail" : "",
    "phone" : "",
    "okved" : "",
    "site" : "",
    "contractor" : true,
    "customer" : false,
    "employer" : false,
    "personName" : "",
    "lastName" : "",
    "firstName" : "",
    "middleName" : "",
    "post" : "",
    "roles" : [],
    "createAccount" : false,
    "worldSkills": [],
    "specialities": [],
    "offerDevelopment" : true,
    "offerEducation" : true,
    "offerResources" : true
  };

  const useStyles = makeStyles(() => ({
    root: {
      width: 774,
      "& .MuiFormLabel-root": {
        whiteSpace: "nowrap"
      },
      "& .MuiInputBase-input.Mui-disabled": {
        color: "#000"
      }
    },
    progress: {
      display: "flex",
      justifyContent: "center"
    },
    heading: {
      fontSize: 14,
      lineHeight: "18px",
      display: "flex",
      alignItems: "center",
      color: "#000000",
      margin: "8px 0"
    },
    block: {
      margin: "0 0 32px 0"
    },
    blockrow: {
      marginTop: 16
    },
    blockfieldValue: {
      marginTop: 8
    },
    checkbox: {
      "& > .MuiCheckbox-colorPrimary.Mui-checked": {
        color: "rgba(0, 127, 189, 0.7);"
      }
    },
    label: {
      fontSize: 12
    },
    svgIcon:{
      display: "inline-block",
      marginBottom: "-8px",
      marginRight: "8px"
    },
    typofield: {
      width: 120,
      minWidth: 120,
      paddingRight: 16
    },
    typovalue: {
      fontSize: 12,
    }
  }));

  const formatDate = date =>
      date ? format(parseISO(date), "dd.MM.yy", { locale: ru }) : null;

const OrgRequestFullInfo = ({
  initialData,
  infoData,
  disabled,
  editmode,
  onFormChange
}) => {

const [data, setData] = React.useState(initialData || defaultData);
const {
  dataSources,
  getRegionList,
  getMunicipalList,
  getSpecialitiesList,
  getWorldSkillsList,
  getRolesList
} = useRequestInfo();

const {date, number, statusId, statusName, type, typeName,
        scanFileId, scanMimeType, scanFileName, scanSize,
        contractor, customer, employer, resultStatusId, resultStatusName } = infoData;

const { name, shortName, region, municipal, email, phone, okved, site,
        firstName, lastName, middleName, post, createAccount,
        offerDevelopment, offerEducation, offerResources,
        worldSkills, specialities, comment, accountEmail, roles
      } = data;

  const classes = useStyles();

  useEffect(() => {
    getRegionList();
    getSpecialitiesList();
    getWorldSkillsList();
    getRolesList();
  }, []);

  useEffect(() => {
    if (region) getMunicipalList(region);
  }, [region]);

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };
    setData(newState);
    onFormChange(newState);
  };

 let link = '/work/api/file/' + scanFileId;

  return (
        <div className={classes.root}>
            <Typography className={classes.heading}>Заявка №{number} от {formatDate(date)}</Typography>
            <div className={classes.block}>
              <Grid container spacing={1} justify="space-between">
                  <Grid item xs={9} container spacing={1}>
                    <Grid item xs={3}>
                      <Typography
                        className={classes.typofield}
                        variant="caption"
                        color="textSecondary">
                        Статус заявки:
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Typography className={classes.typovalue} variant="caption">
                        {SmallStateIcon(statusId, classes.svgIcon)}
                        <span style={{color: StateTextColor(statusId)}}>{statusName}</span>
                      </Typography>
                    </Grid>
                    {(statusId==1 && resultStatusId) && <>
                    <Grid item xs={3}>
                      <Typography
                        className={classes.typofield}
                        variant="caption"
                        color="textSecondary">
                        Статус письма:
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Typography className={classes.typovalue} variant="caption">
                        {resultStatusName}
                      </Typography>
                    </Grid></>}
                    <Grid item xs={3}>
                      <Typography
                        className={classes.typofield}
                        variant="caption"
                        color="textSecondary">
                        Запрос:
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <Typography className={classes.typovalue} variant="caption">
                        {typeName}
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography
                        className={classes.typofield}
                        variant="caption"
                        color="textSecondary">
                        Роли в системе:
                      </Typography>
                    </Grid>
                    <Grid item xs={9}>
                      <RolesBadges
                        contractor={contractor}
                        customer={customer}
                        employer={employer}/>
                    </Grid>
                  </Grid>
                <Grid item xs={3}>
                  {scanFileId && scanFileName &&
                  <AttachmentCard link={link} fileInfo={{id: scanFileId, mimeType: scanMimeType, fileName: scanFileName, fileSize: scanSize}}/>
                 }
                </Grid>
              </Grid>
            </div>

            <Typography className={classes.heading}>Запрос на регистрацию организации</Typography>
            <div className={classes.block}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  required
                  value={name}
                  onChange={e => onChange("name", e.target.value)}
                  label="Полное наименование организации"
                  disabled={disabled}
                  readOnly={!editmode}
                />
              </Grid>
              <Grid item xs={6}>
                {dataSources.regions &&
                <DataSelect
                  value={region}
                  onChange={value => onChange("region", value.id)}
                  label="Регион"
                  dataSource={dataSources.regions}
                  disabled={disabled || !editmode}
                />}
              </Grid>
              <Grid item xs={6}>
                {dataSources.municipals &&
                <DataSelect
                  value={municipal}
                  onChange={value => onChange("municipal", value.id)}
                  label="Муниципальное образование"
                  dataSource={dataSources.municipals}
                  disabled={disabled || !region || !editmode}
                />}
              </Grid>
              <Grid item xs={3}>
                <TextField
                  required
                  value={email}
                  onChange={e => onChange("email", e.target.value)}
                  label="E-mail"
                  disabled={disabled}
                  readOnly={!editmode}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  required
                  value={phone}
                  onChange={e => onChange("phone", e.target.value)}
                  label="Телефон"
                  disabled={disabled}
                  inputComponent={TextMaskPhone}
                  readOnly={!editmode}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  value={okved}
                  onChange={e => onChange("okved", e.target.value)}
                  label="ОКВЭД"
                  disabled={disabled}
                  readOnly={!editmode}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  value={site}
                  onChange={e => onChange("site", e.target.value)}
                  label="Сайт"
                  disabled={disabled}
                  readOnly={!editmode}
                />
              </Grid>
            </Grid>
            </div>

            <Typography className={classes.heading}>Представитель</Typography>
            <div className={classes.block}>
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <TextField
                    required
                    value={lastName}
                    onChange={e => onChange("lastName", e.target.value)}
                    label="Фамилия"
                    disabled={disabled}
                    readOnly={!editmode}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    required
                    value={firstName}
                    onChange={e => onChange("firstName", e.target.value)}
                    label="Имя"
                    disabled={disabled}
                    readOnly={!editmode}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    required
                    value={middleName}
                    onChange={e => onChange("middleName", e.target.value)}
                    label="Отчество"
                    disabled={disabled}
                    readOnly={!editmode}
                  />
                </Grid>
                <Grid item xs={3}>
                  <TextField
                    value={post}
                    onChange={e => onChange("post", e.target.value)}
                    label="Должность"
                    disabled={disabled}
                    readOnly={!editmode}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                      control={
                        <Checkbox
                          onChange={(_, val) => onChange("createAccount", val)}
                          value="checked"
                          checked={createAccount}
                          color="primary"
                          disabled={!editmode}
                        />
                      }
                      label="Создать учётную запись"
                      classes={{
                        label: classes.label,
                        root: classes.checkbox
                      }}
                  />
                </Grid>
                {createAccount &&
                <><Grid item xs={6}>
                  <TextField
                    value={accountEmail}
                    onChange={e => onChange("accountEmail", e.target.value)}
                    label="Логин (e-mail)"
                    disabled={disabled}
                    readOnly={!editmode}
                  />
                </Grid>
                <Grid item xs={6}>
                  {dataSources.roles &&
                  <DataSelect
                    value={roles}
                    multiple
                    getOptionLabel={option =>`${option.name}`}
                    onChange={value => onChange("roles", value)}
                    label="Роли в системе"
                    dataSource={dataSources.roles}
                    disableClearable={false}
                    disabled={disabled || !editmode}
                  />}
                </Grid></>}
              </Grid>
            </div>

            <Typography className={classes.heading}>Виды услуг организации-подрядчика для ЦОПП</Typography>
            <div className={classes.block}>
              <div>
              <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(_, val) => onChange("offerDevelopment", val)}
                      value="checked"
                      checked={offerDevelopment}
                      color="primary"
                      disabled={!editmode}
                    />
                  }
                  label="Разработка образовательных программ и цифровых учебных материалов"
                  classes={{
                    label: classes.label,
                    root: classes.checkbox
                  }}
              />
            </div>
            <div>
              <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(_, val) => onChange("offerEducation", val)}
                      value="checked"
                      checked={offerEducation}
                      color="primary"
                      disabled={!editmode}
                    />
                  }
                  label="Проведение обучения"
                  classes={{
                    label: classes.label,
                    root: classes.checkbox
                  }}
              />
            </div>
            <div>
              <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(_, val) => onChange("offerResources", val)}
                      value="checked"
                      checked={offerResources}
                      color="primary"
                      disabled={!editmode}
                    />
                  }
                  label="Предоставление ресурсов"
                  classes={{
                    label: classes.label,
                    root: classes.checkbox
                  }}
              />
            </div>
            </div>

            <Typography className={classes.heading}>Компетенции</Typography>
            {dataSources.worldSkills &&
            <div className={classes.block}>
              <DataSelect
                value={worldSkills}
                multiple
                getOptionLabel={option =>
                  `${option.cis} | ${option.typeName} | ${option.name}`
                }
                onChange={value => onChange("worldSkills", value)}
                label=""
                dataSource={dataSources.worldSkills}
                disableClearable={false}
                disabled={disabled || !editmode}
              />
            </div>}

            <Typography className={classes.heading}>Профессии / Специальности</Typography>
            {dataSources.specialities &&
            <div className={classes.block}>
              <DataSelect
                value={specialities}
                multiple
                getOptionLabel={option => `${option.code} | ${option.name}`}
                renderOption={option => `${option.code} ${option.name}`}
                onChange={value => onChange("specialities", value)}
                label=""
                dataSource={dataSources.specialities}
                disabled={disabled || !editmode}
              />
            </div>}
        </div>
    );
  };

  export default OrgRequestFullInfo;
